"use strict";

var _regeneratorRuntime = require("/drone/src/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/drone/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/drone/src/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NTP_SERVER_STG = 'https://sso.buildstaging.com/rest/v1/currenttimeserver';
var NTP_SERVER_PROD = 'https://sso.hotmart.com/rest/v1/currenttimeserver';

var NtpService = /*#__PURE__*/function () {
  function NtpService(isProd) {
    _classCallCheck(this, NtpService);

    this.url = isProd ? NTP_SERVER_PROD : NTP_SERVER_STG;
  }

  _createClass(NtpService, [{
    key: "getEpochTime",
    value: function getEpochTime() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var localTime, response, time, serverTime, diff;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                localTime = Date.now() / 1000 | 0; // Current date in seconds.

                _context.prev = 1;
                _context.next = 4;
                return fetch(this.url);

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                time = _context.sent;
                serverTime = +new Date(time) / 1000 | 0;
                diff = serverTime - localTime;
                return _context.abrupt("return", Promise.resolve(localTime + diff));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                console.error('[NTP]', _context.t0);
                return _context.abrupt("return", Promise.resolve(localTime));

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 13]]);
      }));
    }
  }]);

  return NtpService;
}();

exports.default = NtpService;